import { Button } from '@cian/ui-kit';
import * as React from 'react';

import { TFlatViewButtonComponent } from '../../types';

export const FlatViewButton: TFlatViewButtonComponent = ({ onClick, disabled }) => {
  return (
    <Button theme="fill_secondary" size="M" onClick={onClick} disabled={disabled} fullWidth>
      Записаться на просмотр
    </Button>
  );
};
